const ITEMS = ["Push", "Pull", "Squat", "Bend & Lift", "Rotation", "Endurance", "Train for life"];

export default function Marquee() {
  const row = (
    <div className="flex shrink-0 items-center">
      {ITEMS.map((item, i) => (
        <span key={i} className="flex items-center">
          <span
            className={`font-display uppercase leading-none text-[13vw] sm:text-[8vw] px-6 sm:px-10 ${
              i % 2 === 0 ? "text-zinc-800" : "text-stroke"
            }`}
          >
            {item}
          </span>
          <span className="w-2.5 h-2.5 sm:w-3 sm:h-3 bg-volt rotate-45 shrink-0" />
        </span>
      ))}
    </div>
  );

  return (
    <div
      data-testid="marquee-section"
      className="relative overflow-hidden border-y border-zinc-800/80 py-6 sm:py-10 bg-ink"
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee">
        {row}
        {row}
      </div>
    </div>
  );
}
